import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Axios from "axios";

//STYLES
import * as ViewerStyles from "../styles/viewer";

function PDFLibraryViewer() {
    const [files, setFiles] = useState([]);
    const [settings, setSettings] = useState({
        headings: true,
        dates: true
    });

    useEffect(() => {
        onStart();
    }, []);

    function onStart() {
        Axios.post("/pods/pdfLibraryFE/getFiles")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    const heading = data.settings.find((set) => set.setting == "headings").value;
                    const date = data.settings.find((set) => set.setting == "dates").value;

                    setSettings((prevState) => {
                        return { ...prevState, headings: heading == "true", dates: date == "true" };
                    });

                    for (const file of data.files) {
                        file.hover = false;
                    }

                    console.log(data.files);

                    setFiles(data.files);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOnClick(filename) {
        window.open(`./content/PDFLibrary/${filename}`, "_blank");
    }

    function handleMoveOver(uuid) {
        const temp = [...files];

        temp.find((file) => file.uuid == uuid).hover = true;

        setFiles(temp);
    }

    function handleMoveLeave(uuid) {
        const temp = [...files];

        temp.find((file) => file.uuid == uuid).hover = false;

        setFiles(temp);
    }

    return (
        <div>
            {settings.headings && (
                <Row>
                    {settings.dates && (
                        <Col sm={3} style={ViewerStyles.headingDate}>
                            Date
                        </Col>
                    )}
                    <Col style={ViewerStyles.headingName}>Name</Col>
                </Row>
            )}
            {files.map((file, index) => {
                return (
                    <Row key={index}>
                        {settings.dates && (
                            <Col sm={3} className="pdfLibary_dateCell" onClick={handleOnClick.bind(this, file.filename)}>
                                {file.date}
                            </Col>
                        )}
                        <Col
                            style={file.hover ? ViewerStyles.selected : ViewerStyles.notSelected}
                            onMouseEnter={handleMoveOver.bind(this, file.uuid)}
                            onMouseLeave={handleMoveLeave.bind(this, file.uuid)}
                            className="pdfLibary_fileCell"
                            onClick={handleOnClick.bind(this, file.filename)}
                        >
                            {file.name}
                        </Col>
                    </Row>
                );
            })}
        </div>
    );
}

export default PDFLibraryViewer;
